<template>
    <div class="contain desFile">
        <div class="header-box">
            <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
        </div>
        <div class="box">
            <div class="build-bar" style="height:auto;flex-wrap:wrap;padding-top:10px;padding-bottom:10px;">
                <!-- <el-button v-for="item in bars" :key="item.id" style="margin:5px 10px;" :class="cuid==item.id?'primary':''" @click="setCuid(item)">{{item.name}}</el-button> -->
                <div v-for="item in bars" :key="item.id">
                    <el-popover
                    placement="right"
                    width="400"
                    trigger="hover">
                        <el-table :data="item.list" :show-header="false">
                            <el-table-column prop="name" label="" width="200"></el-table-column>
                            <el-table-column prop="count" label=""></el-table-column>
                            <el-table-column prop="completeType" label="">
                                <template slot-scope="scope">
                                    <el-badge v-if="scope.row.completeType=='1'" is-dot class="btn-dot mid-dot yellow" />
                                    <el-badge v-else-if="scope.row.completeType=='2'" is-dot class="btn-dot mid-dot green" />
                                    <el-badge v-else is-dot class="btn-dot mid-dot red" />
                                </template>
                            </el-table-column>
                        </el-table >
                        <el-button slot="reference" style="margin:5px 10px;" :class="cuid==item.id?'primary':''" @click="setCuid(item)">
                            {{item.name}} 
                            <el-badge is-dot class="btn-dot" :class="{'red':!item.completeType||item.completeType=='0', 'yellow':item.completeType=='1', 'green':item.completeType=='2'}" />
                        </el-button>
                    </el-popover>
                </div>
            </div>
            <div class="box-content flex-wrap">
                <el-tabs type="border-card" style="width:100%;height:100%;">
                    <el-tab-pane v-for="item in dataList" :key="item.id" class="flex-wrap" style="align-content: flex-start;">
                        <span slot="label"> {{item.name}} <el-badge is-dot class="btn-dot mid-dot" :class="{'red':!item.completeType||item.completeType=='0', 'yellow':item.completeType=='1', 'green':item.completeType=='2'}" /></span>
                        <div style="width:100%;height:4vh;display: flex;align-content: center;align-items: center;justify-content: flex-end;justify-items: flex-end;">
                            <span>当前状态：</span>
                            <el-select v-model="item.completeType" placeholder="请选择" style="width:6vw;" @change="changeStatus(item,item.completeType)">
                                <el-option value="0" disabled label="未开始">
                                    <span style="float: left"><el-badge is-dot class="btn-dot mid-dot red" /></span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">未开始</span>
                                </el-option>
                                <el-option value="1" label="未完成">
                                    <span style="float: left"><el-badge is-dot class="btn-dot mid-dot yellow" /></span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">未完成</span>
                                </el-option>
                                <el-option value="2" label="已完成">
                                    <span style="float: left"><el-badge is-dot class="btn-dot mid-dot green" /></span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">已完成</span>
                                </el-option>
                            </el-select>
                            <el-button type="primary" @click="addFileFun(item.materiaType)" style="height: 40px;margin-left:1vw;">添加文件夹</el-button>
                            <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;">
                                <el-upload
                                class="upload-demo"
                                v-bind:action="uploadUrl"
                                :headers="uploadHead"
                                :data={type:213}
                                multiple
                                :objectBind='item.materiaType'
                                :show-file-list="false"
                                :on-success="fileSuccess1">
                                    <el-button size="small" class="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                        <div style="flex:1;display:flex;flex-wrap: wrap;" class="item-con">
                            <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="child in item.attachments" :key="child.id">
                                <p class="title nowrap" style="width:100%;min-height: 10px;" :title="child.attachmentName">{{child.attachmentName}}</p>
                                <p  style="width:100%;">
                                    <img v-if="child.fileType=='0'" style="width:60px;height:60px;" src="../../../assets/image/file.png" @click="showChild(child.id)" />
                                    <img v-if="child.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(child.attachment,child.attachmentName)" />
                                    <img v-else-if="child.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(child.attachment,child.attachmentName)" />
                                    <img v-else-if="child.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(child.attachment,child.attachmentName)" />
                                    <img v-else-if="child.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(child.attachment,child.attachmentName)" />
                                    <img v-else-if="child.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(child.attachment,child.attachmentName)" />
                                </p>
                                <p v-if="child.fileType!='0'" style="width:100%;"><img style="width:40px;height:40px;" src="../../../assets/image/downfile.png" @click="downFile(child.attachment)" /></p>
                                <p v-if="child.fileType=='0'" class="name nowrap" style="width:100%;">{{child.folderName}}</p>
                                <p v-if="child.fileType!='0'" class="name" style="width:100%;">{{child.userName}}上传</p>
                                <p v-if="child.fileType!='0'" class="time" style="width:100%;">{{child.createDate}}</p>
                            </div>
                        </div>
                        <div style="width:150px;" class="flex-wrap item-con">
                            <div style="width:100%;display:flex;flex-wrap:wrap;justify-content: center;" @click="showModel(item.materiaType,1)">
                                <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                                <p style="width:100%;">模板文档</p>
                            </div>
                            <div style="width:100%;display:flex;flex-wrap:wrap;justify-content: center;"  @click="showWord(item.materiaType,2)">
                                <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                                <p style="width:100%;">原件文档</p>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <!-- <div class="table-item" style="height:250px;" v-for="item in dataList" :key="item.id">
                    <div style="width:150px;" class="item-con">
                        {{item.name}}
                    </div>
                    <div style="flex:1;display:flex;flex-wrap: wrap;" class="item-con">
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="child in item.attachments" :key="child.id">
                            <p class="title nowrap" style="width:100%;min-height: 10px;" :title="child.attachmentName">{{child.attachmentName}}</p>
                            <p  style="width:100%;">
                                <img v-if="child.fileType=='0'" style="width:60px;height:60px;" src="../../../assets/image/file.png" @click="showChild(child.id)" />
                                <img v-if="child.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(child.attachment,child.attachmentName)" />
                                <img v-else-if="child.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(child.attachment,child.attachmentName)" />
                            </p>
                            <p v-if="child.fileType!='0'" style="width:100%;"><img style="width:40px;height:40px;" src="../../../assets/image/downfile.png" @click="downFile(child.attachment)" /></p>
                            <p v-if="child.fileType=='0'" class="name nowrap" style="width:100%;">{{child.folderName}}</p>
                            <p v-if="child.fileType!='0'" class="name" style="width:100%;">{{child.userName}}上传</p>
                            <p v-if="child.fileType!='0'" class="time" style="width:100%;">{{child.createDate}}</p>
                        </div>
                        <el-button type="primary" @click="addFileFun(item.materiaType)" style="height: 40px;margin-top: 40px;">添加文件夹</el-button>
                        <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;padding-top: 45px;">
                            <el-upload
                              class="upload-demo"
                              v-bind:action="uploadUrl"
                              :headers="uploadHead"
                              :data={type:213}
                              :objectBind='item.materiaType'
                              :show-file-list="false"
                              :on-success="fileSuccess1">
                                <el-button size="small" class="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div>
                    <div style="width:150px;" class="flex-wrap item-con">
                        <div style="width:100%;display:flex;flex-wrap:wrap;justify-content: center;" @click="showModel(item.materiaType,1)">
                            <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                            <p style="width:100%;">模板文档</p>
                        </div>
                        <div style="width:100%;display:flex;flex-wrap:wrap;justify-content: center;"  @click="showWord(item.materiaType,2)">
                            <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                            <p style="width:100%;">原件文档</p>
                        </div>
                    </div>
                </div> -->
            </div>
            <!-- 新增窗口 -->
            <el-dialog
                title="添加设计变更及签证"
                width="500px"
                :visible.sync="addFormVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="编号：" prop="changeNumber">
                        <el-input v-model="addForm.changeNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="变更简述：" prop="changeDescribe">
                        <el-input type="textarea" :rows="2" placeholder="请输入简述内容" v-model="addForm.changeDescribe"></el-input>
                    </el-form-item>
                    <el-form-item label="结果：" prop="changeResults">
                        <el-input type="textarea" :rows="2" placeholder="请输入简述内容" v-model="addForm.changeResults"></el-input>
                    </el-form-item>
                    <el-form-item label="变更时间：">
                        <el-date-picker v-model="addForm.changeTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 新增文件夹窗口 -->
            <el-dialog
                title="添加文件夹"
                width="500px"
                :visible.sync="addFileVis"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addFile" ref="addFile" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="文件名：">
                        <el-input v-model="addFile.folderName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addFileVis = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddFile">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
// import PDF from 'pdfjs-dist'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            pageTitle:'',
            labelPosition:'right',
            listData:[],
            groupId:"",
            bars:base.maint,
            cuid:'',
            curFile:{
                type:'',
                materiaType:'',
                groupId:'',
                entProjectId:'',
                attachment:'',
                attachmentName:'',
                attachmentType:'',
                userId:'',
                userName:'',
            },
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            entProjectId:'',
            dataList:[],
            pages: [],
            pdfDoc: null,
            addFormVisible:false,
            addForm:{
                id:'',
                changeNumber:'',
                changeDescribe:'',
                changeResults:'',
                changeTime:util.myTime.getCurTime()
            },
            fileName:'',
            wordUrl:'',//word文档地址
            nodeName:base.maintNode,
            rules:{
                changeNumber: [
                    { required: true, message: '请输入编号', trigger: 'blur' }
                ],
                changeDescribe: [
                    { required: true, message: '请输入简述', trigger: 'blur' }
                ],
                changeResults: [
                    { required: true, message: '请输入结果', trigger: 'blur' }
                ],
            },
            dataText:"数据加载中...",
            addFileVis:false, //添加文件夹
            addFile:{
                materiaType:'',
                folderName:''
            },
            isFirstCreate:false, //第一个文件是否正在上传
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.entProjectId = this.$route.params.id
        this.fixCuid()
        //var cuid = base.pdm.length+1+base.trans.length
        //this.cuid = util.session.get('cuid')||cuid
        // this.nodeName = [
        //     [{id:'1',name:'施工许可证'},{id:'2',name:'施工临时用水申报'},{id:'3',name:'施工临时用电申报'},{id:'4',name:'评标报告'}],
        //     [{id:'1',name:'项目建设证件管理'}],
        //     [],
        //     [{id:'1',name:'变更文件'},{id:'2',name:'负面清单文件'}],
        //     [{id:'1',name:'合同价款及附件'},{id:'2',name:'审计报告'}],
        //     [{id:'1',name:'日常检查'},{id:'2',name:'节假日检查'},{id:'3',name:'质检站检查'}],
        //     [{id:'1',name:'白蚁'},{id:'2',name:'环保'},{id:'3',name:'消防'},{id:'4',name:'人防'},{id:'5',name:'其他'}],
        //     [{id:'1',name:'移交清单'},{id:'2',name:'移交签字'}],
        //     [{id:'1',name:'决算审计管理'}],
        //     [{id:'1',name:'项目后评价管理'},{id:'2',name:'项目维护管理'}]
        // ]
        this.getData()
        this.getTotalData()
    },
    methods:{
        //确定cuid
        fixCuid(){
            var cuid = util.session.get('cuid')
            var result = ''
            for(var i=0;i<this.bars.length;i++){
                if(cuid==this.bars[i].id){
                    result = this.bars[i].id
                }
            }
            if(result==''){
                this.cuid = base.pdm.length+1+base.trans.length
            }else{
                this.cuid = cuid
            }
        },
        //获取数据
        getData(){
            var that = this
            myHttp.getAttachmentType({
                type:this.cuid,
                groupId:this.groupId,
                entProjectId:this.entProjectId,
                id:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.pageTitle = resp.data.data.project.name
                    that.getDataByType(resp.data.data)
                    
                }
            })
        },
        //根据type展示数据
        getDataByType(data){
            var dataList = [];
            var nodeCode = this.nodeName
            var str = nodeCode[parseInt(this.cuid)-(base.pdm.length+1+base.trans.length)]
            for(var i=0;i<str.length;i++){
                var list = data[str[i].val]||[]
                var obj = {}
                if(list.length==0){
                    obj = {
                        attachments:[],
                        materiaType:str[i].id
                    }
                }else{
                    obj = list[0]
                    var li = obj.attachments||[]
                    for(var j=0;j<obj.attachments.length;j++){
                        //obj.attachments[j].fileType = this.getImg(obj.attachments[j].attachment)
                        obj.attachments[j].fileType = obj.attachments[j].attachment&&''!=obj.attachments[j].attachment?this.getImg(obj.attachments[j].attachment):'0'
                    }
                }
                obj.name = this.getNameByType(obj.materiaType)
                dataList.push(obj)
            }
            this.dataList = dataList
        },
        //获取节点名称
        getNameByType(type){
            var result = ''
            var list = this.nodeName[parseInt(this.cuid)-(base.pdm.length+1+base.trans.length)]
            for(var i=0;i<list.length;i++){
                if(list[i].id==type){
                    result = list[i].name
                }
            }
            return result
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        handleEdit(index,row){
            this.$router.push('/overFileSec/'+this.entProjectId+'/'+this.cuid+'/'+row.id)
        },
        
        //展示
        setCuid(row){
            this.cuid = row.id
            util.session.set('cuid',this.cuid)
            if(row.id=='15'){
                this.getListData()
            }else{
                this.getData()
            }
            
        },
        //获取变更数据
        getListData(){
            var that = this
            myHttp.getAttachmentTypeList({
                type:this.cuid,
                groupId:this.groupId,
                entProjectId:this.entProjectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.entity||[]
                    that.listData = list
                    if(list.length==0){
                        that.dataText = "暂无数据"
                    }
                }else{
                    that.$message.error(resp.data.msg);
                }
                
            },function(){})
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        /**申报材料 */
        //上传成功
        fileSuccess1(res,file,opt,index){
            if(res.code==200){
                // this.curFile.type = this.cuid
                // this.curFile.materiaType = index
                // this.curFile.groupId = this.groupId
                // this.curFile.entProjectId = this.entProjectId
                // this.curFile.attachment = res.data.saveUrls
                var name = file.name.split('.')
                name.pop()
                name = name.join();
                // this.curFile.attachmentName = name
                // this.curFile.userId = this.$store.state.user.id
                // this.curFile.userName = this.$store.state.user.name
                // this.curFile.attachmentType = 3
                // this.submitFun(this.curFile)
                var obj = {
                    type:this.cuid,
                    materiaType:index,
                    groupId:this.groupId,
                    entProjectId:this.entProjectId,
                    attachment:res.data.saveUrls,
                    attachmentName:name,
                    userId:util.session.get('user').id,
                    userName:util.session.get('user').name,
                    attachmentType:3
                }

                if(this.isFirstCreate){
                    var that = this
                    setTimeout(function(){
                        that.submitFun(obj)
                    },1000)
                }else{
                    this.submitFun(obj)
                }
                
            }else{
                this.$message.error(res.msg);
            }
            
        },

        /**
         * 添加方法
         */
        submitFun(data){
            let that = this
            // window.open(base.fileView+'/addTask?url='+base.httpCtx+data.attachment);
            this.isFirstCreate = true
            myHttp.postAttachment(data).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message({type: 'success',message: '文件添加成功!'});
                    that.getData()
                    that.isFirstCreate = false
                }else{
                    that.$message.error(resp.data.msg);
                    that.isFirstCreate = false
                }
            })
        },
        //查看文档
        showFile(url,name){
            var that = this
            //if (!/.(pdf|PDF)$/.test(url)) {
                //window.open( "http://view.officeapps.live.com/op/view.aspx?src=" +base.netCtx+ url, "_blank");
                // window.open( "http://view.officeapps.live.com/op/embed.aspx?src=" +base.netCtx+ url, "_blank");
                // console.log(url)
                //window.open('http://file.tongsheng01.com:8012/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
                window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
            // }else{
            //     myHttp.getAttachmentFtp({
            //         fileUrl:base.httpCtx,
            //         fileName:url
            //     }).then(function(resp){
            //         if(resp.data.code=='200'){
            //             that.addFormVisible = true
            //             that.fileName = name
            //             var url = resp.data.data.buff
            //             that.loadFile(url)
            //         }else{
            //             that.$message.error(resp.data.msg);
            //         }
            //     })
            // }
        },
        // 新增的数据
        sumbitAddRow(formName) {
            var that = this;
            // this.addForm.userId = this.$store.state.user.id
            // this.addForm.userName = this.$store.state.user.name
            this.addForm.groupId = this.groupId
            this.addForm.entProjectId = this.entProjectId,
            this.addForm.type = this.cuid
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(that.addForm.id==''){
                        myHttp.postChange(that.addForm).then(function(resp){
                            if(resp.data.code=="200"){
                                that.$message.success("添加成功");
                                that.addFormVisible = false;
                                that.getListData();
                            }else{
                                that.$message.error(resp.data.msg);
                            }
                        },function(){})
                    }else{
                        // myHttp.putEntProject(that.addForm).then(function(resp){
                        //     if(resp.data.code=="200"){
                        //         that.$message.success("添加成功");
                        //         that.addFormVisible = false;
                        //         that.currentPage = 1;
                        //         that.getData();
                        //     }else{
                        //         that.$message.error(resp.data.msg);
                        //     }
                        // },function(){});
                    }
                }
            });
        },
        //下载文档
        downFile(url){
            window.open(base.httpCtx+url)
        },
        //查看模板
        showModel(id,type){
            this.$router.push('/folder/'+this.cuid+'/'+id+'/'+type+'/'+this.entProjectId)
            // if(id==''||undefined==id)return;
            // var that = this
            // this.$router.push('/overModel/'+this.cuid+'/'+id+'/'+type)
        },
        //查看原件
        showWord(id,type){
            this.$router.push('/folder/'+this.cuid+'/'+id+'/'+type+'/'+this.entProjectId)
            
        },

        //添加方法
        addFileFun(index){
            this.addFileVis = true
            this.addFile.materiaType = index
        },
        //添加文件夹
        sumbitAddFile(){
            var that = this
            if(this.addFile.folderName==''){
                this.$message.error('请输入文件名称');
                return
            }
            this.addFile.type = this.cuid
            //this.addForm.materiaType = this.materiaType
            this.addFile.groupId = this.groupId
            this.addFile.entProjectId = this.entProjectId
            //this.addFile.parentId = ''
            this.addFile.attachmentType = '3'
            this.addFile.userId = util.session.get('user').id
            this.addFile.userName = util.session.get('user').name
            myHttp.postAttachment(this.addFile).then(function(resp){
                //console.log(resp)
                if(resp.data.code=='200'){
                    that.$message.success('添加成功');
                    that.addFileVis = false
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        //查看文档下面的文件
        showChild(id){
            this.$router.push('/desModel/'+this.cuid+'/'+this.materiaType+'/3/'+this.entProjectId+'/'+id)
            // this.$router.push('/desFileModel/'+id)
        },

        /**
         * 获取弹出框数据统计
         */
        getTotalData(){
            var that = this
            var types = ''
            for(var i=0;i<this.bars.length;i++){
                if(types==''){
                    types = this.bars[i].id
                }else{
                    types += ','+this.bars[i].id
                }
            }
            myHttp.statisticalAttachmentType({
                types:types,
                groupId:this.groupId,
                entProjectId:this.entProjectId,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.AttachmentType||[]
                    var barsList = that.bars
                    that.bars = []
                    for(var i=0;i<list.length;i++){
                        //barsList[i].completeType = list[i].completeType && ''!=list[i].completeType?list[i].completeType:'0'
                        var child = that.nodeName[i] //list[i].list
                        barsList[i].list = []
                        var type1 = false  //判断是否有红色未开始  0
                        var type2 = false  //判断是否有黄色未结束  1
                        var type3 = false  //判断是否有绿色已结束  2
                        for(var j=0;j<child.length;j++){
                            // child[j].name = that.getNameByCuid(list[i].type,child[j].materiaType)
                            var str = that.getInfoByCuid(child[j].id,list[i].list)
                            var obj = {
                                name:child[j].name,
                                completeType: str.completeType||'',
                                count: str.count||0,
                                materiaType: child[j].id
                            }
                            barsList[i].list.push(obj)
                            if(str.completeType=='1'){
                                type2 = true
                            }else if(str.completeType=='2'){
                                type3 = true
                            }else{
                                type1 = true
                            }
                        }
                        if(type1 && !type2 && !type3){
                            barsList[i].completeType = '0'
                        }else if(type3 && !type1 && !type2){
                            barsList[i].completeType = '2'
                        }else{
                            barsList[i].completeType = '1'
                        }
                        // barsList[i].list = child
                    }
                    that.bars = barsList
                }
            })
        },

        //根据cuid和type获取名称
        getInfoByCuid(id,list){
            var str = {}
            for(var i=0;i<list.length;i++){
                if(id==list[i].materiaType){
                    str = list[i]
                }
            }
            return str
        },

    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 85px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 80px );
        /* background: #fff; */
        overflow: auto;
        display: flex;
        align-content: flex-start;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .el-button{
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
    }
    .primary{
        background-color: #17b2fe;
        border-color: #17b2fe;
        color: #fff;
    }
    .table-item{
        width: 100%;
        min-height: 50px;
        display: flex;
        border-bottom: 15px solid #ecf0f5;
        background: #fff;
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .item-con{
        padding: 10px;
    }
    .item-con p{
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }
    .item-con img{
        cursor: pointer;
    }
    .table-item-sec{
        width: 100%;
        height: 50px;
        background: #17B2FE;
        color: #fff;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 15px solid #ecf0f5;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
    .btn-dot .is-dot{
        top: 2px;
        width: 12px;
        height: 12px;
    }
    .green .is-dot{
        background-color: #67C23A;
    }
    .yellow .is-dot{
        background-color: #E6A23C;
    }
    .red .is-dot{
        background-color: #F56C6C;
    }
    .mid-dot{
        top: 4px;
    }
    .desFile .box-content .el-tabs__content{
        height: calc( 100% - 40px );
        overflow: auto;
    }
    .desFile .box-content .el-tab-pane{
        height: 100%;
    }
    .box-content .el-tabs__item{
        margin-right: 10px;
        background: #eee;
    }
</style>